import React from 'react';
import Contacts from '../components/Contacts';

export default function Contact() {
    return (
        <div>
            <h1 class='mt-5'>Contact</h1>
            <br />
                <Contacts />
            <br />
        </div>
    );
}